module.exports = __webpack_public_path__ + "static/media/_dollar.23b8b69d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/_dollar.jpg
// module id = 55
// module chunks = 0